// Process latex
//
'use strict';

module.exports = (md, options) => {
  options = options || {};
  options.server = options.server || 'https://math.now.sh';
  options.style = options.style || '';
  const purifiedURL = (latex) => {
    return encodeURIComponent(latex).replace('(', '%28').replace(')', '%29');
  };

  let Inline = (latex) => {
    try {
      return `<img src="${options.server}?tex=${purifiedURL(latex)}" style="${options.style}display:inline-block;margin: 0;vertical-align: middle;"/>`;
    } catch (error) {
      console.error(error);
      return latex;
    }
  };

  let Block = (latex) => {
    try {
      return `<p style="${options.style}"><img src="${options.server}?tex=${purifiedURL(
        latex,
      )}" /></p>`;
    } catch (error) {
      console.error(error);
      return latex;
    }
  };

  const inlineFormulaRegex = /(\?<!\\)\$(.+?)(\?<!\\)\$/g;
  const displayFormulaRegex = /(\$\$.+?\$\$|\\\[.+?\\\]|\\\(.+?\\\))/g;

  const handleFormula = (state, silent) => {
    let match;
    let pos = state.pos;
    let max = state.posMax;
    let content, token;

    // Check for inline formula
    inlineFormulaRegex.lastIndex = pos;
    match = inlineFormulaRegex.exec(state.src);
    if (match && match.index === pos) {
      if (!silent) {
        content = match[1]; // The content inside the delimiters
        token = state.push('latex_inline', 'math', 0);
        token.content = content;
        token.markup = '$';
      }
      state.pos += match[0].length;
      return true;
    }

    // Check for display formula
    displayFormulaRegex.lastIndex = pos;
    match = displayFormulaRegex.exec(state.src);
    if (match && match.index === pos) {
      if (!silent) {
        content = match[0].slice(2, -2); // The content inside the delimiters
        token = state.push('latex_display', 'math', 0);
        token.content = content;
        token.markup = match[0].startsWith('$$')
          ? '$$'
          : match[0].startsWith('\\[')
            ? '\\['
            : '\\(';
      }
      state.pos += match[0].length;
      return true;
    }

    return false;
  };

  // Regular expression to match LaTeX formulas including brackets and parentheses
  md.inline.ruler.before('escape', 'latex_inline', handleFormula);

  // Add inline rule for display formulas
  md.inline.ruler.before('escape', 'latex_display', handleFormula);

  md.renderer.rules.latex_inline = function (tokens, idx) {
    return Inline(tokens[idx].content);
  };
  md.renderer.rules.latex_display = function (tokens, idx) {
    return Inline(tokens[idx].content);
  };
};
